export default "__VITE_ASSET__d63d0dd5__"